export { default } from './EventDetail'
